import Error from "next/error"
import React from "react"
import ArtworkDetailPage from "../../../../features/pages/ArtworkDetailPage"
import galleryApiService from "../../../../services/galleryApiService"
import { idExtractor } from "../../../../services/utils/idExtractor"
import { slugify } from "../../../../services/utils/slugify"

const ArtworkDetail = ({
  artworkDetails,
  relatedArtworks,
  errorCode,
  gallery,
}) => {
  if (errorCode) {
    return <Error statusCode={404} />
  }

  return (
    <ArtworkDetailPage
      artworkDetails={artworkDetails}
      relatedArtworks={relatedArtworks}
      gallery={gallery}
    />
  )
}

export const getServerSideProps = async ({ params, res, req }) => {
  const { id, artwork } = params
  console.log(`User-Agent: ${req.headers["user-agent"]}`)
  // If given an ID find the domain and redirect
  const isNumericId = /^\d+$/.test(id)
  if (isNumericId) {
    const response = await galleryApiService
      .gallery(id)
      .catch((err) => err.response)
    if (!response || response.status !== 200) {
      return { notFound: true }
    }
    return {
      redirect: {
        destination: `/galleries/${response.data.domain}/artworks/${artwork}`,
        permanent: true,
      },
    }
  }
  try {
    const [artwork_id, ...rest] = idExtractor(artwork)
    const [response, relatedResponse] = await Promise.all([
      galleryApiService.artwork(artwork_id),
      galleryApiService.relatedArtworks(artwork_id),
    ])
    const galleryResponse = await galleryApiService.gallery(
      response.data.galleryid,
    )

    if (rest.length === 0 && !!response.data) {
      res.writeHead(301, {
        Location: `/artworks/${artwork_id}-${slugify(response.data.title)}`,
      })
      res.end()
    }

    return {
      props: {
        errorCode: !response.data,
        artworkDetails: response.data,
        relatedArtworks: relatedResponse.data,
        gallery: galleryResponse.data,
      },
    }
  } catch (e) {
    return {
      props: {
        errorCode: true,
      },
    }
  }
}

export default ArtworkDetail
